import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SelectField from '../../elements/form/SelectField'
import { fetchSubjects } from '../../../store/actions/subjectsActions'
import ModalActionButton from '../../elements/ModalActionButton'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'

const NewElectiveSubject = ({close, reload}) => {
    const subjectsSelector = useSelector((state) => state.subjects)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchSubjects('', 0, 0))
        
    }, [dispatch])

    const [subjectPayload, setSubjectPayload] = React.useState({
        subject: '',
        classes: []
    })

    const [activeClasses, setActiveClasses] = React.useState([])
    const [validationErrors, setValidationErrors] = React.useState({})

    const [processing, setProcessing] = React.useState(false)

    const validateForm = () => {
        let errors = {}
        if(!subjectPayload.subject || subjectPayload.subject === '') {
            errors.subject = true
        }
        if(!subjectPayload.classes || subjectPayload.classes.length === 0) {
            errors.classes = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushElectiveSubject = async () => {
        try {
            if(processing) return
            const errors = validateForm()
            if(Object.values(errors).includes(true)) {
                return
            }
            setProcessing(true)

            const headers = authHeader()
            await axios.post(`${baseUrl}/academic-settings`, {electiveSubjects: [subjectPayload]}, { headers })
            dispatch({
                type: SET_SUCCESS,
                payload: 'Elective subject created successfully'
            })
            reload()
            setTimeout(() => {
                close()
            }, 50);
        } catch (error) {
            console.log('error creating elective subject: ', error)
            dispatch({
                type: ERROR,
                error
            })
        } finally {
            setProcessing(false)
        }
    }

    const toggleClassSelection = (classId) => {
        const selectedClasses = [...subjectPayload.classes]
        if(selectedClasses.includes(classId)) {
            setSubjectPayload({...subjectPayload, ...{classes: selectedClasses.filter(cl => cl !== classId)}})
        } else {
            setSubjectPayload({...subjectPayload, ...{classes: [...selectedClasses, classId]}})
        }
    }

    return (
        <div className='w-full'>
            <p className='text-sm text-gray-500'>
                Select a subject and choose in which classes it should be set as a prerequisite.
            </p>
            {subjectsSelector?.subjects?.subjects && subjectsSelector?.subjects?.subjects?.length > 0 && <div className='w-full mt-[10px] mb-[10px]'>
                <SelectField
                    selectOptions={subjectsSelector?.subjects?.subjects}
                    inputLabel="Select Subject"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    // preSelected=''
                    fieldId="subject"
                    hasError={validationErrors.subject}
                    preSelected={subjectPayload.subject ? subjectPayload.subject : ''}
                    preSelectedLabel={'_id'}
                    requiredField
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setSubjectPayload({...subjectPayload, ...{subject: value._id}})
                        setActiveClasses(value.classes)
                    }}
                />
            </div>}

            {activeClasses && activeClasses.length > 0 && <div className='w-full mt-[10px] mb-[10px]'>
                <p className='text-sm text-gray-600 mb-2'>Select the classes in which this subject should be set as an elective.</p>
                {activeClasses.map((cl, index) => (
                    <button key={index} onClick={()=>{toggleClassSelection(cl.class._id)}} className={`mr-2 m-2 px-3 py-2 font-semibold rounded text-sm font-space-grotesk transition duration-200 ${subjectPayload.classes.includes(cl.class._id) ? 'bg-vcm-purple text-white hover:bg-purple-700' : 'bg-gray-200 text-gray-700 hover:bg-gray-100'}`}>
                        {cl.class.name}
                    </button>

                ))}
                {validationErrors.classes && <p className="text-xs text-red-600 mt-1">Please select at least one class</p>}
            </div>
            }

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create Elective Subject`}
                    buttonAction={()=>{pushElectiveSubject()}}
                    processing={processing}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewElectiveSubject